import RecomputedService from './recomputed-data';

export default {
  getRecomputedCalendar(payload) {
    return RecomputedService.getRecomputedData(
      '/api/stripe/calendar/recomputed',
      payload
    )
  }
}

